import { AxiosResponse } from 'axios';
import {
  SET_KNOWLEDGE_BASE_ARTICLES,
  SET_KNOWLEDGE_BASE_ARTICLE,
  SET_ERRORMSG,
} from '@/store/mutation_types';
import {
  CLEAR_KNOWLEDGE_BASE_ARTICLE_ISLOADING,
  DELETE_KNOWLEDGE_BASE_ARTICLE,
  EDIT_KNOWLEDGE_BASE_ARTICLE,
  GET_KNOWLEDGE_BASE_ARTICLES,
  GET_KNOWLEDGE_BASE_ARTICLE,
  REGISTER_KNOWLEDGE_BASE_ARTICLE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import KnowledgeBaseArticle from '@/services/knowledge_base_article';
import { Module } from 'vuex';
import {
  EditKnowledgeBaseArticle,
  RegisterKnowledgeBaseArticle,
  GetKnowledgeBaseArticle,
} from '@/dtos/knowledge_base_article.dto';

const knowledgeBaseArticle: Module<any, {}> = {
  state: {
    knowledgeBaseArticle: {
      data: null,
      isLoading: false,
    },
    knowledgeBaseArticles: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    knowledgeBaseArticle: (state: { knowledgeBaseArticle: any }) => state.knowledgeBaseArticle,
    knowledgeBaseArticles: (state: { knowledgeBaseArticles: any }) => state.knowledgeBaseArticles,
  },
  mutations: {
    [SET_KNOWLEDGE_BASE_ARTICLE]: (
      state: { knowledgeBaseArticle: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.knowledgeBaseArticle.data = payload.data) : null,
        (state.knowledgeBaseArticle.isLoading = payload.isLoading);
    },
    [SET_KNOWLEDGE_BASE_ARTICLES]: (
      state: { knowledgeBaseArticles: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.knowledgeBaseArticles.data = payload.data) : null,
        (state.knowledgeBaseArticles.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_KNOWLEDGE_BASE_ARTICLE]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseArticle.registerKnowledgeBaseArticle(
        payload as RegisterKnowledgeBaseArticle
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { isLoading: false });
        return false;
      }
    },
    [GET_KNOWLEDGE_BASE_ARTICLES]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLES, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseArticle.getKnowledgeBaseArticles(
        payload as GetKnowledgeBaseArticle
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_ARTICLES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_ARTICLES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_ARTICLES, { isLoading: false });
        return false;
      }
    },
    [GET_KNOWLEDGE_BASE_ARTICLE]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseArticle.getKnowledgeBaseArticles(
        payload as GetKnowledgeBaseArticle
      );

      if (result) {
        if (result.data.status) {
          const data = Array.isArray(result.data.data) ? result.data.data[0] : result.data.data;
          commit(SET_KNOWLEDGE_BASE_ARTICLE, { data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { isLoading: false });
        return false;
      }
    },
    [EDIT_KNOWLEDGE_BASE_ARTICLE]: async ({ commit }: any, payload: any) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseArticle.editKnowledgeBaseArticle(
        payload as EditKnowledgeBaseArticle
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { isLoading: false });
        return false;
      }
    },
    [DELETE_KNOWLEDGE_BASE_ARTICLE]: async ({ commit }: any, payload: string) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: true });

      const result: AxiosResponse = await KnowledgeBaseArticle.deleteKnowledgeBaseArticle(payload);

      if (result) {
        if (result.data.status) {
          commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_KNOWLEDGE_BASE_ARTICLE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_KNOWLEDGE_BASE_ARTICLE_ISLOADING]: ({ commit }) => {
      commit(SET_KNOWLEDGE_BASE_ARTICLE, { isLoading: false });
      commit(SET_KNOWLEDGE_BASE_ARTICLES, { isLoading: false });
    },
  },
};

export default knowledgeBaseArticle;
